import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import LocalStorageBackend from 'i18next-localstorage-backend';
import moment from 'moment';

import {defaultNS, fallbackLanguage, nameSpaces, resources} from './generated/locales/config';

i18n.use(initReactI18next).init({
  resources: resources,
  fallbackLng: fallbackLanguage,
  ns: nameSpaces,
  defaultNS: defaultNS,
  interpolation: {
    escapeValue: false,
    format: function(value, format) {
      if (value instanceof Date) return moment(value).format(format);
      return value;
    },
  },
  backend: {
    backends: [LocalStorageBackend],
    backendOptions: [
      {
        expirationTime: 7 * 24 * 60 * 60 * 1000, // 7 days
      },
    ],
  },
});

export default i18n;
